/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-dialog-actions[_ngcontent-%COMP%]{justify-content:flex-end}.mat-dialog-content[_ngcontent-%COMP%]{text-align:center}button[_ngcontent-%COMP%]{padding-left:1.5rem;padding-right:1.5rem;background-color:#21d196;font-weight:500;color:#fff;box-shadow:none;margin-left:.5rem!important;margin-right:.5rem!important}.title[_ngcontent-%COMP%]{margin-bottom:1rem;font-size:1.5rem;font-weight:700}.body[_ngcontent-%COMP%]{word-break:break-word;color:#969595;margin-bottom:1rem}"];
export { styles as styles };
